// @flow
import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import * as _ from "lodash";
import API from "../../api";

import * as ActionTypes from '../../constants/ActionTypes';
import * as Actions from '../../actions';

function* getAvailableSlotsSaga(action) {
    try {
        const { storeId, date, userTimezone } = action.payload;
        const queryParams = `shop=${storeId}&date=${date}&user_timezone=${userTimezone}`;
        
        const response = yield API.get(`/users/appointments/slots?${queryParams}`);
        yield put(Actions.getAvailableSlotsSuccess(response.data));
    } catch (error) {
        yield put(Actions.getAvailableSlotsFailure(error));
    }
}

function* bookAppointmentSaga(action) {
    try {
        const response = yield API.post(
            `/users/appointments/book`,
            action.payload,
            { withCredentials: true }
        );
        yield put(Actions.bookAppointmentSuccess(response.data));
    } catch (error) {
        yield put(Actions.bookAppointmentFailure(error));
    }
}

function* getUserAppointmentsSaga(action) {
    try {
        const queryParams = new URLSearchParams(action.payload).toString();
        const query = queryParams ? `?${queryParams}` : '';
        
        const response = yield API.get(
            `/users/appointments/my-appointments${query}`,
            { withCredentials: true }
        );
        yield put(Actions.getUserAppointmentsSuccess(response.data));
    } catch (error) {
        yield put(Actions.getUserAppointmentsFailure(error));
    }
}


function* cancelAppointmentSaga(action) {
    try {
        const { appointmentId, reason } = action.payload;
        const response = yield API.put(
            `/users/appointments/${appointmentId}/cancel`,
            { reason },
            { withCredentials: true }
        );
        yield put(Actions.cancelAppointmentSuccess(response.data));
    } catch (error) {
        yield put(Actions.cancelAppointmentFailure(error));
    }
}


function* getAppointmentDetailsSaga(action) {
    try {
        const { appointmentId, userTimezone } = action.payload;
        const queryParams = `user_timezone=${userTimezone}`;
        
        const response = yield API.get(
            `/users/appointments/${appointmentId}?${queryParams}`,
            { withCredentials: true }
        );
        yield put(Actions.getAppointmentDetailsSuccess(response.data));
    } catch (error) {
        yield put(Actions.getAppointmentDetailsFailure(error));
    }
}

function* getTimezonesSaga(action) {
    try {
        const response = yield API.get(`/users/appointments/timezones`);
        yield put(Actions.getTimezonesSuccess(response.data));
    } catch (error) {
        yield put(Actions.getTimezonesFailure(error));
    }
}

export default function* UserAppointmentsSaga() {
    yield takeLatest(ActionTypes.GET_AVAILABLE_SLOTS_REQUEST, getAvailableSlotsSaga);
    yield takeEvery(ActionTypes.BOOK_APPOINTMENT_REQUEST, bookAppointmentSaga);
    yield takeLatest(ActionTypes.GET_USER_APPOINTMENTS_REQUEST, getUserAppointmentsSaga);
    yield takeEvery(ActionTypes.USER_CANCEL_APPOINTMENT_REQUEST, cancelAppointmentSaga);
    yield takeLatest(ActionTypes.GET_APPOINTMENT_DETAILS_REQUEST, getAppointmentDetailsSaga);
    yield takeLatest(ActionTypes.GET_TIMEZONES_REQUEST, getTimezonesSaga);
}
